// @flow

export class A {}
export const B = class cB {}

export default class MyClass {
    constructor(a: A, b: B) {}
}
